export default __webpack_public_path__ + "static/media/img4.0553b3ef.png";